/**
 * @file themeManager.js
 * @description Applies themes in response to state changes.
 */

import StateManager from './stateManager.js';

class ThemeManager {
    constructor() {
        this.themes = ['aegis', 'blueprint'];
        this.currentTheme = null;
    }

    init() {
        const savedTheme = localStorage.getItem('cyber-os-theme');
        const initialTheme =
            savedTheme && this.themes.includes(savedTheme)
                ? savedTheme
                : StateManager.get('theme');

        // Apply once, silently
        this.applyTheme(initialTheme, true);

        // 🔔 React to state changes
        StateManager.subscribe('theme', (newTheme) => {
            if (this.themes.includes(newTheme)) {
                this.applyTheme(newTheme);
            }
        });
    }

    applyTheme(themeName, silent = false) {
        if (this.currentTheme === themeName) return;

        this.currentTheme = themeName;
        document.body.setAttribute('data-theme', themeName);
        localStorage.setItem('cyber-os-theme', themeName);

        if (!silent) {
            console.log(`[Theme] Applied: ${themeName}`);
        }
    }
}

const ThemeManagerInstance = new ThemeManager();
export default ThemeManagerInstance;
